import { useIsomorphicLayoutEffect } from "@gatsby-plugin-generic-page/hooks/useIsomorphicLayoutEffect"
import usePageAnalyticsConfigurationQuery from "~/hooks/usePageAnalyticsConfigurationQuery"
import { setPageAnalyticsConfiguration } from "~/lib/pageAnalytics"

/**
 * Hands the Squidex page analytics configuration over to `onRouteUpdate`, which
 * enriches the page_view event with it (ONESTORE-298).
 *
 * Mounted once in `wrapRootElement`, so it survives client-side navigation.
 * A layout effect is required — see the note in `~/lib/pageAnalytics`.
 */
export default function PageAnalyticsInitializer(): null {
  const { applicationName, customUrls } = usePageAnalyticsConfigurationQuery()

  useIsomorphicLayoutEffect()(() => {
    setPageAnalyticsConfiguration({ applicationName, customUrls })
  }, [applicationName, customUrls])

  return null
}
